import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import masterListReducer from "./masterListSlice";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const persistConfing = {
  key: "root",
  version: 1,
  storage,
};

const reducer = combineReducers({
  auth: authReducer,
  masterList: masterListReducer,
});

const persistedReducer = persistReducer(persistConfing, reducer);
// eslint-disable-next-line no-undef

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
